export default function removeAnchorRoleAttribute() {
	window.onload = () => {
		document.querySelectorAll('a[role="link"]').forEach((link) => {
			link.removeAttribute('role');
		});
	};
}



// WEBPACK FOOTER //
// ./wp-content/plugins/core/assets/theme/js/src/accessibility/remove-anchor-role-attribute.js